import * as React from 'react'
import moment from 'moment'
import { CommunicationInstanceAllStatus } from '@120wateraudit/communications-types'

export const TrackingLink = ({
  trackingId,
  status,
  createdOn
}: {
  trackingId: string
  status: string
  createdOn: string
}) => {
  // The conditionals below check if the mail is over 365 days old, USPS may reuse tracking numbers after that. For more context please look at H2O-1288 which goes more in depth
  // as to why we switched from checking for 120 to 365 days
  // This also checks if the status is delivered, opened, ReturnedToSender, SendError, bounced, or there is no trackingId which should cover
  // Created and Processed status as they shouldn't have a trackingId and it will be null and hide tracking if so
  const maxAge = moment().subtract(365, 'd').format('YYYY-MM-DD')

  if (
    !trackingId ||
    moment(createdOn).isBefore(maxAge) ||
    status === CommunicationInstanceAllStatus.Delivered ||
    status === CommunicationInstanceAllStatus.Opened ||
    status === CommunicationInstanceAllStatus.Bounced ||
    status === CommunicationInstanceAllStatus.ReturnedToSender ||
    status === CommunicationInstanceAllStatus.SendError
  ) {
    return <span>--</span>
  }

  return (
    <a
      href={`https://tools.usps.com/go/TrackConfirmAction?&tLabels=${trackingId}`}
      rel="noreferrer"
      target="_blank">
      View Status
    </a>
  )
}
